export default "__VITE_ASSET__5c577bf6__"